import React, { FC } from 'react';
import { createBreakpoints, Picture } from '../Picture/Picture';
import { useTranslation } from '@wix/wix-i18n-config';
import { BREAKPOINTS_CONFIG, SOURCE_IMAGE_SIZES } from '../../../../../consts';

interface TemplateImageProps {
  desktop16x9Img?: string;
  isLazyLoad?: boolean;
  previewImg?: string;
  alt?: string;
  className?: string;
  onLoad?: () => void;
  onLoadStart?: () => void;
}

export const TemplateImage: FC<TemplateImageProps> = ({
  desktop16x9Img,
  previewImg,
  isLazyLoad,
  alt,
  className,
  onLoad,
  onLoadStart,
}) => {
  const imagePath = desktop16x9Img || previewImg;
  const sourceImageSize = desktop16x9Img
    ? SOURCE_IMAGE_SIZES['16x9']
    : SOURCE_IMAGE_SIZES.preview;
  const breakpoints = createBreakpoints(
    BREAKPOINTS_CONFIG,
    SOURCE_IMAGE_SIZES['16x9'],
  );
  const { t } = useTranslation();

  return (
    <Picture
      isLazyLoad={isLazyLoad}
      imagePath={imagePath || ''}
      sourceImageSize={sourceImageSize}
      breakpoints={breakpoints}
      alt={t('templates.img.altText', alt)}
      onLoad={onLoad}
      onLoadStart={onLoadStart}
      imageClassName={className}
    />
  );
};
